import(/* webpackMode: "eager" */ "/home/chungbn/web_game/dev-testnet/app/page.tsx");
